export default [{
  title: 'Orders',
  id: 'orders-main-menu',
  sub: [{
    path: { name: 'orders' },
    title: 'Orders',
    visibleFor: ['ROLE_CODE_MANAGER', 'ROLE_ORDER_MANAGER']
  }, {
    path: { name: 'dissector' },
    title: 'Code dissector',
    visibleFor: ['ROLE_CODE_DISSECTOR', 'ROLE_ORGANIZATION_ADMIN', 'ROLE_CODE_MANAGER']
  }, {
    path: { name: 'setCodeStatus' },
    title: 'Code statuses',
    visibleFor: ['ROLE_CODE_STATUS_MANAGER']
  }, {
    path: { name: 'statistics' },
    title: 'Statistics',
    visibleFor: ['ROLE_KC_STATISTICS_VIEWER']
  }]
}, {
  title: 'Validation',
  id: 'validation-main-menu',
  sub: [{
    path: { name: 'batchValidator' },
    title: 'Batch validator',
    visibleFor: ['ROLE_BATCH_AUTHENTICATOR']
  }, {
    path: { name: 'validationSimulator' },
    title: 'Validation Simulator',
    visibleFor: ['ROLE_SECTION_MANAGER', 'ROLE_ATI_VIEWER', 'ROLE_ATI_MANAGER']
  }, {
    path: { name: 'entryChannels' },
    title: 'Channels',
    visibleFor: ['ROLE_ATI_VIEWER', 'ROLE_ATI_MANAGER']
  }, {
    path: { name: 'validationLog' },
    title: 'Log',
    visibleFor: ['ROLE_VALIDATION_LOG_VIEWER']
  }, {
    path: { name: 'blacklist' },
    title: 'Code Blacklist',
    visibleFor: ['ROLE_ADMIN']
  }]
}, {
  title: 'Configuration',
  id: 'configuration-main-menu',
  sub: [{
    path: { name: 'products' },
    title: 'Products',
    visibleFor: ['ROLE_PRODUCT_MANAGER', 'ROLE_PRODUCT_READER', 'ROLE_ORGANIZATION_ADMIN']
  }, {
    path: { name: 'productMetadataSchemas' },
    title: 'Product metadata schemas',
    visibleFor: ['ROLE_PRODUCT_METADATA_SCHEMA_READER', 'ROLE_PRODUCT_METADATA_SCHEMA_MANAGER']
  }, {
    path: { name: 'atis' },
    title: 'Validation responses',
    visibleFor: ['ROLE_ATI_VIEWER', 'ROLE_ATI_MANAGER']
  }, {
    path: { name: 'atiGroups' },
    title: 'Validation response groups',
    visibleFor: ['ROLE_ATI_VIEWER', 'ROLE_ATI_MANAGER']
  }, {
    path: { name: 'metadataschemas' },
    title: 'Metadata schemas',
    visibleFor: ['ROLE_METADATA_SCHEMA_READER', 'ROLE_METADATA_SCHEMA_MANAGER']
  }, {
    path: { name: 'codeStatuses' },
    title: 'Code statuses',
    visibleFor: ['ROLE_CODE_STATUS_CONFIG_MANAGER']
  }, {
    path: { name: 'codeConfigurations' },
    title: 'Code configurations',
    visibleFor: ['ROLE_ADMIN']
  }, {
    path: { name: 'configuration' },
    title: 'Organization',
    visibleFor: ['ROLE_SECURITY_ADMIN', 'ROLE_ORGANIZATION_ADMIN']
  }]
}, {
  title: 'Management',
  id: 'management-main-menu',
  sub: [{
    path: { name: 'createOrganization' },
    title: 'New organization',
    visibleFor: ['ROLE_SECURITY_ADMIN']
  }, {
    path: { name: 'viewOrganization' },
    title: 'Organization',
    visibleFor: ['ROLE_SECURITY_ADMIN', 'ROLE_ORGANIZATION_ADMIN']
  }, {
    path: { name: 'users' },
    title: 'Users',
    visibleFor: ['ROLE_SECURITY_ADMIN', 'ROLE_ORGANIZATION_ADMIN']
  }, {
    path: { name: 'groups' },
    title: 'Groups',
    visibleFor: ['ROLE_SECURITY_ADMIN', 'ROLE_ORGANIZATION_ADMIN']
  }, {
    path: { name: 'auditTrail' },
    title: 'Audit trail',
    visibleFor: ['ROLE_SECURITY_ADMIN']
  }]
}, {
  title: 'System',
  id: 'system-main-menu',
  sub: [{
    path: { name: 'authentications' },
    title: 'Authentications',
    visibleFor: ['ROLE_SECURITY_ADMIN']
  }, {
    path: { name: 'banned' },
    title: 'Banned IPs',
    visibleFor: ['ROLE_SECURITY_ADMIN']
  }, {
    path: { name: 'cacheStatus' },
    title: 'Cache status',
    visibleFor: ['ROLE_ADMIN']
  }, {
    path: { name: 'sspEvents' },
    title: 'Events',
    visibleFor: ['ROLE_SUPPORT']
  }]
}]



// WEBPACK FOOTER //
// ./src/data/menu-items/core.js